export const CarouselLeftArrowIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="27" viewBox="0 0 24 27" fill="none">
            <g filter="url(#filter0_d_8062_19843)">
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M14.7091 3L16.1233 4.41421L8.82843 11.7091L16.1233 19.0039L14.7091 20.4181L6 11.7091L14.7091 3Z"
                      fill="#FCFCFC"/>
            </g>
            <defs>
                <filter id="filter0_d_8062_19843" x="2" y="1" width="18.123" height="25.418"
                        filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                   result="hardAlpha"/>
                    <feOffset dy="2"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8062_19843"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8062_19843" result="shape"/>
                </filter>
            </defs>
        </svg>
    );
};
